import { Box, Grid } from "@mui/material";
import * as React from "react";
import { Card } from "../../general/card";
import { Metric } from "../../general/custom";
import RangeSelector from "../../range_selector/range_selector";
import { ElionChart, InternalChart, ProfitChart, SOCChart } from "./elion_overview_charts";
import { fetchAdminOverview } from "../../../scripts/api_v2/admin_client";
import useBackend from "../../../hooks/use_backend";
import { useQuery } from "@tanstack/react-query";
import { REACT_QUERY_KEYS } from "../../../enums/react_query_key_enum";
import { startOfDay, endOfDay } from "date-fns";

export default function OverviewTab({ required_privilege }) {
  const today = new Date();
  const [range, setRange] = React.useState({
    startDate: startOfDay(today),
    endDate: endOfDay(today),
    key: "selection",
  });
  const backend = useBackend();

  let {
    data: overview,
    error,
    isLoading,
    refetch,
  } = useQuery({
    queryKey: [REACT_QUERY_KEYS.ADMIN_OVERVIEW, backend.fetch, range],
    queryFn: () => fetchAdminOverview(backend.fetch, range.startDate),
    refetchInterval: 30000,
  });

  return (
    <>
      <Grid container spacing={2} px={2} py={2}>
        <Grid item md={4} xs={12}>
          <Card sx={{ height: 350, pb: 6 }} title="Overview">
            <Box display="flex" flexDirection="row" justifyContent="center" alignItems="center" pb={3}>
              <RangeSelector range={range} setRange={setRange} singleDate />
            </Box>
            <SmallOverview overview={overview?.overview} />
          </Card>
        </Grid>
        <Grid item md={8} xs={12}>
          <Card sx={{ height: 350, pb: 6 }} title="Profit">
            {overview?.profits ? <ProfitChart profits={overview?.profits} /> : null}
          </Card>
        </Grid>
        <Grid item md={12} xs={12}>
          <Card sx={{ height: 350, pb: 6 }} title="Elion">
            {overview?.metering ? <ElionChart metering={overview?.metering} /> : null}
          </Card>
        </Grid>
        <Grid item md={12} xs={12}>
          <Card sx={{ height: 350, pb: 6 }} title="Consumption">
            {overview?.metering ? <InternalChart metering={overview?.metering} /> : null}
          </Card>
        </Grid>
        <Grid item md={12} xs={12}>
          <Card sx={{ height: 350, pb: 6 }} title="State of Charge">
            {overview?.metering ? <SOCChart metering={overview?.metering} /> : null}
          </Card>
        </Grid>
      </Grid>
    </>
  );
}

function SmallOverview({ overview }) {
  return (
    <>
      <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center">
        <Metric name="Opgeladen" value={overview ? overview.charge_kwh + " kWh" : "-"} />
        <Metric name="Ontladen" value={overview ? overview.discharge_kwh + " kWh" : "-"} />
      </Box>
      <Box display="flex" flexDirection="row" alignItems="center" justifyContent="center">
        <Metric name="Aantal" value={overview ? overview.count : "-"} />
        {/* <Metric name="Elion" value={overview ? Math.round(100*overview.elion_fraction) + "%" : "-"}/> */}
      </Box>
    </>
  );
}
